import { Recipient } from '../../types/loft'

export const getGraphUrl = () => 'https://graph.microsoft.com/v1.0'

export const getGraphUrlMessages = () => `${getGraphUrl()}/me/messages`

export const mapRecipient = (recipient: Recipient) => {
  return {
    emailAddress: {
      address: recipient.emailAddress,
      name: recipient.displayName,
    },
  }
}

export const getConvertedId = (id: string) =>
  Office.context.mailbox
    .convertToRestId(id, Office.MailboxEnums.RestVersion.v2_0)
    .replaceAll('/', '-')
